var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.buttonClass,attrs:{"type":_vm.type,"disabled":_vm.disabled},on:{"click":_vm.submitButton}},[(_vm.icon)?_c('i',{class:_vm.iconClass}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }